import api from '@/services/api/master-data-management.js';
import { immerable } from 'immer';
import { useState } from 'react';

class MasterDataDocument {
    [immerable] = true
    constructor(params) {
        this.id = params.id
        this.name = params.name
        this.description = params.description
        this.category = params.category
        this.modified = params.modified
        this.modifiedBy = params.modifiedBy
        this.jsonSchema = params.jsonSchema
        this.uniqueKeysOfSchema = params.uniqueKeysOfSchema
    }
}

function serialize(entry) {
    return {
        id: entry.id,
        name: entry.name,
        description: entry.description,
        category: entry.category,
        modified: entry.modified,
        modifiedBy: entry.modifiedBy,
        jsonSchema: entry.jsonSchema,
        uniqueKeysOfSchema: entry.uniqueKeysOfSchema
    }
}

const useMasterDataManagement = () => {
    const [masterDataList, setMasterDataList] = useState([]);
    const [masterDataListDetails,   setMasterDataListDetails] = useState([]);
    const [masterDataLoading, setMasterDataLoading] = useState(false);
    const [masterDataErrorMsg, setMasterDataErrorMsg] = useState();
    const [metaData, setMetaData] = useState(null)

    async function fetchMasterDataUpload(params) {
        setMasterDataLoading(true)
        const [error, response] = await api.getMasterData(params);
        setMasterDataLoading(false)
        if (error) {
            return setMasterDataErrorMsg(error)
        }

        const { entities, meta } = response;
        const serializedData = entities?.map(entry => serialize(entry));
        const newItems = serializedData?.map(dataParams => new MasterDataDocument(dataParams));
        setMetaData(meta);
        setMasterDataList(newItems);
    }

    async function fetchMasterDataUploadDetails(id, params) {
        setMasterDataLoading(true)
        const [error, response] = await api.getMasterDataEntityDetails(id, params);
        setMasterDataLoading(false)
        if (error) {
            return setMasterDataErrorMsg(error)
        }

        const { records, meta } = response;
        setMetaData(meta);
        setMasterDataListDetails(records);
    }

    async function updateMasterData(params) {
        setMasterDataLoading(true)
        const [error, data] = await api.updateMasterData(params);
        setMasterDataLoading(false)

        return [error, data]
    }

    return {
        masterDataList,
        metaData,
        masterDataLoading,
        masterDataErrorMsg,
        fetchMasterDataUpload,
        masterDataListDetails,
        fetchMasterDataUploadDetails,
        updateMasterData
    }

}

export default useMasterDataManagement